import {
  SET_TOP_BANNER_IMAGE_PATH,
  SET_TITLE,
  SET_SUBTITLE
} from './constants';

const initialState = {
  title: '',
  subTitle: '',
  bannerImagePath: null
};

const reducer = (state = initialState, {type, payload}) => {
  switch (type) {
    case SET_TOP_BANNER_IMAGE_PATH:
      return {
        ...state,
        bannerImagePath: payload || initialState.bannerImagePath
      };
    case SET_TITLE:
      return {
        ...state,
        ...{title: payload}
      };
    case SET_SUBTITLE:
      return {
        ...state,
        ...{subTitle: payload}
      };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/features/shared/topBanner/reducer.js